import {
  getAuth,
  getAdditionalUserInfo,
  onAuthStateChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  GoogleAuthProvider,
  OAuthProvider,
} from 'firebase/auth';
import { app } from './';
import users from '../models/users';

export const auth = getAuth(app);

export const onAuthChanged = callback => onAuthStateChanged(auth, async (authUser) => {
  if (!authUser) {
    callback(null);
    return;
  }

  const tokenResult = await authUser.getIdTokenResult();
  const userDoc = await users.get(authUser.uid);
  const membershipDocs = await users.getOrgMemberships(authUser.uid);

  callback(Object.assign(authUser, {
    claims: tokenResult.claims,
    doc: userDoc,
    memberships: membershipDocs,
  }));
});

export const signInWithGoogle = () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  return signInWithPopup(auth, provider).then((userCredential) => {
    const additionalUserInfo = getAdditionalUserInfo(userCredential);
    return { ...userCredential, additionalUserInfo };
  });
};

export const signInWithApple = () => {
  const provider = new OAuthProvider('apple.com');
  return signInWithPopup(auth, provider).then((userCredential) => {
    const additionalUserInfo = getAdditionalUserInfo(userCredential);
    return { ...userCredential, additionalUserInfo };
  });
};

export const signInWithEmail = (email, password) => (
  signInWithEmailAndPassword(auth, email, password)
);

export const resetPassword = email => sendPasswordResetEmail(auth, email);

export const signOutUser = () => signOut(auth);

window.signOutUser = signOutUser;